import { render, staticRenderFns } from "./sendTeacAngel.vue?vue&type=template&id=0f6f59a7&scoped=true&"
import script from "./sendTeacAngel.vue?vue&type=script&lang=js&"
export * from "./sendTeacAngel.vue?vue&type=script&lang=js&"
import style0 from "./sendTeacAngel.vue?vue&type=style&index=0&id=0f6f59a7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f59a7",
  null
  
)

export default component.exports